import { render } from "./AddOtherTypeofBoat.vue?vue&type=template&id=c135227a"
import script from "./AddOtherTypeofBoat.vue?vue&type=script&lang=js"
export * from "./AddOtherTypeofBoat.vue?vue&type=script&lang=js"
script.render = render

export default script